import React from "react";
import { 
    Level, LevelItem, Divider
} from '@patternfly/react-core';
import Moment from 'moment';

const SummaryVmInfo = ({
    vm,
    ovirtLoading
}) => {

  return (
    <>
        {/* Architecture */}
        <Level>
            <LevelItem><small><b>Architektura:</b></small></LevelItem>
            <LevelItem>
                {ovirtLoading ? "" : vm.cpu.architecture}
            </LevelItem>
        </Level>
        {/* Type */}
        <Level>
            <LevelItem><small><b>Typ:</b></small></LevelItem>
            <LevelItem>
                {vm.type}
            </LevelItem>
        </Level>
        {/* Dystrybucja */}
        <Level>
            <LevelItem><small><b>Dystrybucja:</b></small></LevelItem>
            <LevelItem>
                {ovirtLoading ? "" : vm?.guest_operating_system?.distribution || "N/A"}
            </LevelItem>
        </Level>
        {/* Template */}
        <Level>
            <LevelItem><small><b>Template:</b></small></LevelItem>
            <LevelItem>
                {vm.description}
            </LevelItem>
        </Level>
        {/* Creation time */}
        <Level>
            <LevelItem><small><b>Utworzono:</b></small></LevelItem>
            <LevelItem>
                {Moment(vm.creation_time).format('DD.MM.YYYY H:mm a')}
            </LevelItem>
            <Divider />
        </Level>
    </>
  );
};

export default SummaryVmInfo;